import { FC } from 'react';
import { ServicePortalData } from './service-portal-data';

export const ServicePortalDataContainer: FC = () => {
  return <ServicePortalData />;
};
